import { API } from '@iota/core'
import { GitiumAPI } from '../gitiumlib'
import { GitiumRequest } from '../request'

export default class BaseController {
  protected iota: API
  protected post: GitiumRequest
  protected unpost: GitiumRequest
  constructor(config: GitiumAPI) {
    this.iota = config.iota
    this.post = config.request.POST
    this.unpost = config.request.UN_POST
  }
}
